/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

export interface ScFieldProps<
    FieldValue = any,
    T extends HTMLElement = HTMLElement,
    InputValue = FieldValue,
> extends Omit<
    FieldProps<
        FieldValue,
        FieldRenderProps<FieldValue, T, InputValue>,
        T,
        InputValue
    >,
    'component'
> {
    component?: React.ComponentType<any> | string;
    label?: string;
    className?: string;
    [key: string]: any;
}

const ScField = <
    FieldValue = any,
    T extends HTMLElement = HTMLElement,
    InputValue = FieldValue,
>({
    name,
    component,
    label,
    className,
    ...restProps
}: ScFieldProps<FieldValue, T, InputValue>) => (
    <Field<FieldValue, T, InputValue>
        {...(restProps as any)}
        name={name}
        component={component as any}
        label={label}
        className={className}
    />
);

export default ScField;
